<template>
  <modal
    :show="show"
    @change="$emit('change', $event)"
    width="700"
    :headerClass="
      currentLocale === 'ru'
        ? 'bg-main-orange white--text helvetica-roman fs-18'
        : 'bg-main-orange white--text rubik-medium fs-18'
    "
  >
    <template v-slot:header>
      <span>{{ $t("client") }}</span>
    </template>
    <template v-slot:main>
      <div class="modal-content">
        <div class="tes-text modal-content-text">
          {{ $t("modals.modalCertificate.textPart1") }}
          <strong>{{ $t("modals.modalCertificate.textPart1Strong") }}</strong>
          <br />
          {{ $t("modals.modalCertificate.textPart2") }}
          <strong>{{ $t("modals.modalCertificate.textPart2Strong") }}</strong>
          <br />
          <a href="https://gosuslugi.ru/crt">https://gosuslugi.ru/crt</a>
        </div>
        <v-btn class="ok-btn orange-button mb-5" :class="{ 'button-font': currentLocale === 'tat' }" @click="onOk">{{
          $t("modals.modalCertificate.button")
        }}</v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters } from "vuex";

export default {
  name: "ModalCertificate",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  computed: {
    ...mapGetters("locale", ["currentLocale"])
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onOk() {
      this.$emit("ok");
      this.$emit("change", false);
    }
  }
};
</script>

<style scoped>
.modal-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  padding: 0;
}

.modal-content-text {
  text-align: center;
  padding: 15px 15px 0px 15px;
}

.button-font {
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>
